export default __webpack_public_path__ + "static/media/pipeline-protection-system.ca052d62.jpg";